import React from "react";
import Translation from "../../../services/translation.service";
import ModalWrapperMid from "../modal-wrapper-mid";
import StorefrontTitle from "../storefront-title.component";

export default function AvailableCountriesModal(props) {

    const getFlag = (code) => {
        try {
            return require(`../../../assets/img/flagsRounded/country_${props.allCountriesData[code]?.iso_2code.toLowerCase()}.webp`);
        } catch {
            return "";
        }
    };

    const countryElement = (code) => {
        return <div className="available-custom-country-option">
            <div>
                {getFlag(code) && <img src={getFlag(code)} alt="" /> }
                <span>{Translation.keys[`country_${code}`] || props.allCountriesData[code]?.name || "Country"}</span>
            </div>
            <span>({props.allCountriesData[code]?.dial_code || ""})</span>
        </div>
    }

    return <div className="available-countries-modal">
        <ModalWrapperMid handleToggleModal={props.handleModal}>
            <StorefrontTitle
              title={Translation.keys["stf_countries_flexi_modal_title"]}
              desc={Translation.keys["stf_countries_flexi_modal_desc"]}
            />
            <div className="available-custom-country-option-container custom-scrollbar">
                {props.availableCountries.length > 0 && props.availableCountries.map((item) => {
                    return countryElement(item)
                })}
            </div>
            <button className="common-button" onClick={props.handleModal}>{Translation.keys["stf_close"]}</button>
        </ModalWrapperMid>
  </div>
}